function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import PropTypes from "prop-types";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import omit from "lodash.omit";
import Context from "../Context/Context";
import { contextMenuItemSelector } from "../Context/ContextMenuItem";
import DropdownReactContext from "./DropdownReactContext";
if (typeof window !== "undefined") {
  require("element-closest");
}
const isFocusableMenuItem = element => element && element.hasAttribute(contextMenuItemSelector) && !element.disabled;

/* eslint-disable react/no-find-dom-node */
export default class DropdownContext extends Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("mousedown", this.handleClick);
    document.removeEventListener("mousemove", this.handleMouseMove);
  }
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("mousedown", this.handleClick);
    document.addEventListener("mousemove", this.handleMouseMove);
  }
  handleClick(event) {
    if (!this.context.dropdownRef || !this.context.closeDropdown) {
      return;
    }
    const dropdownRef = this.context.dropdownRef();
    if (dropdownRef && !dropdownRef.contains(event.target) && !this.el.contains(event.target)) {
      return this.context.closeDropdown();
    }
  }
  getFocusedMenuItem() {
    return this.el.querySelector(`[${contextMenuItemSelector}]:focus`);
  }
  getMenuItems() {
    return [...this.el.querySelectorAll(`[${contextMenuItemSelector}]:not(:disabled)`)];
  }
  focusMenuItem(element) {
    const menuItem = element.closest(`[${contextMenuItemSelector}]`);
    if (menuItem && isFocusableMenuItem(menuItem)) {
      menuItem.focus();
    }
  }
  handleMouseMove(event) {
    this.focusMenuItem(event.target);
  }
  handleKeyDown(event) {
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        return this.handleDirectionKey("nextElementSibling", 1);
      case "ArrowUp":
        event.preventDefault();
        return this.handleDirectionKey("previousElementSibling", -1);
      case "Tab":
      case "Escape":
        event.preventDefault();
        return this.context.closeDropdown();
    }
  }
  handleDirectionKey(sibling, delta) {
    const focusedMenuItem = this.getFocusedMenuItem();
    const siblingElement = focusedMenuItem && isFocusableMenuItem(focusedMenuItem[sibling]) ? focusedMenuItem[sibling] : null;
    if (siblingElement) {
      return siblingElement.focus();
    }
    const menuItems = this.getMenuItems();
    const index = focusedMenuItem && menuItems.indexOf(focusedMenuItem);
    if (focusedMenuItem && menuItems[index + delta]) {
      return menuItems[index + delta].focus();
    } else if (!focusedMenuItem && menuItems.length > 0) {
      menuItems[0].focus();
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(Context, _extends({}, omit(this.props, ["focusOnOpen", "onRequestCloseDropdown"]), {
      ref: el => this.el = ReactDOM.findDOMNode(el)
    }));
  }
}
_defineProperty(DropdownContext, "defaultProps", {
  maxHeight: "30rem",
  position: "top",
  width: "14.5rem"
});
_defineProperty(DropdownContext, "contextType", DropdownReactContext);